import { useRef } from "react";

import classes from "./TodoForm.module.css";

const TodoForm = (props) => {
  const todoInputRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredValue = todoInputRef.current.value;

    if (enteredValue.trim().length > 0) {
      props.onEnterTodo(enteredValue);
      todoInputRef.current.value = ""; // Leert das Textfeld
    }
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <input type="text" ref={todoInputRef} />
      <button>{props.loading ? "Sending..." : "Add Todo"}</button>
    </form>
  );
};

export default TodoForm;
